import styled from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {STRONG_BLUE} from '../../../../globalVariables/GlobalVariables';

export const quillWrap = styled.div<{direction: 'ltr' | 'rtl'}> `
    direction: ${p => p.direction};
    .ql-container.ql-snow {
        border: none;
        font-size: inherit;
    }

    .ql-editor {
        text-align:  ${p => p.direction==='ltr' ? 'left' : 'right'};
        min-height: 40px;
        outline: none;
        padding: ${getSpacing('spaceSm')} ${getSpacing('spaceMd')};
        direction: ${p => p.theme.direction};
        margin: 0;
        .variable {
            font-weight: bold;
            color: ${STRONG_BLUE};
        }
    }
`;
